import type { commonTypes } from '@ltvco/refresh-lib/v1';

const normalizePart = (value: string | undefined | null): string =>
  (value ?? '').trim().toLowerCase();

const DIRECTION_ABBREVIATIONS: Record<string, string> = {
  n: 'north',
  s: 'south',
  e: 'east',
  w: 'west',
  ne: 'northeast',
  nw: 'northwest',
  se: 'southeast',
  sw: 'southwest',
};

const STREET_TYPE_ABBREVIATIONS: Record<string, string> = {
  aly: 'alley',
  ave: 'avenue',
  blvd: 'boulevard',
  cir: 'circle',
  ct: 'court',
  cv: 'cove',
  dr: 'drive',
  hwy: 'highway',
  ln: 'lane',
  pkwy: 'parkway',
  pl: 'place',
  plz: 'plaza',
  rd: 'road',
  sq: 'square',
  st: 'street',
  ter: 'terrace',
  trl: 'trail',
  way: 'way',
};

const normalizeDirection = (value: string | undefined | null): string => {
  const part = normalizePart(value);
  return DIRECTION_ABBREVIATIONS[part] ?? part;
};

const normalizeStreetType = (value: string | undefined | null): string => {
  const part = normalizePart(value);
  return STREET_TYPE_ABBREVIATIONS[part] ?? part;
};

const CANONICALIZERS: Partial<
  Record<
    keyof commonTypes.ParsedAddress,
    (value: string | undefined | null) => string
  >
> = {
  street_type: normalizeStreetType,
  pre_direction: normalizeDirection,
  post_direction: normalizeDirection,
};

export const addressPartsMatch = (
  a: commonTypes.ParsedAddress | null | undefined,
  b: commonTypes.ParsedAddress | null | undefined
): boolean => {
  if (!a || !b) {
    return false;
  }

  const keys: (keyof commonTypes.ParsedAddress)[] = [
    'primary_address_number',
    'street_name',
    'street_type',
    'pre_direction',
    'post_direction',
    'unit_number',
    'zip5',
  ];

  return keys.every((key) => {
    const canonicalize = CANONICALIZERS[key] ?? normalizePart;
    return canonicalize(a[key]) === canonicalize(b[key]);
  });
};
